export const turboGames = {
  turbo: {
    aero: {
      href: "/casino/aggapturbogames-aero",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Aero.webp",
      alt: "Aero",
      name: "Aero",
      providerName: "Turbo Games",
    },
    BallAndBall: {
      href: "/casino/aggapturbogames-ball-and-ball",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Ball&Ball.webp",
      alt: "Ball & Ball",
      name: "Ball & Ball",
      providerName: "Turbo Games",
    },
    Bayraktar: {
      href: "/casino/aggapturbogames-bayraktar",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Bayraktar.webp",
      alt: "Bayraktar",
      name: "Bayraktar",
      providerName: "Turbo Games",
    },
    Bubbles: {
      href: "/casino/aggapturbogames-bubbles",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Bubbles.webp",
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "Turbo Games",
    },
    crashX: {
      href: "/casino/aggapturbogames-crash-x",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/CrashX.webp",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Turbo Games",
    },
    CrashXFootballEdition: {
      href: "/casino/aggapturbogames-crash-x-football-edition",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/CrashXFootballEdition.webp",
      alt: "Crash X Football Edition",
      name: "Crash X Football Edition",
      providerName: "Turbo Games",
    },
    DiceTwice: {
      href: "/casino/aggapturbogames-dice-twice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/DiceTwice.webp",
      alt: "Dice Twice",
      name: "Dice Twice",
      providerName: "Turbo Games",
    },
    DogsStreet: {
      href: "/casino/aggapturbogames-dogs-street",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/DogsStreet.webp",
      alt: "Dogs' Street",
      name: "Dogs' Street",
      providerName: "Turbo Games",
    },
    DoubleRoll: {
      href: "/casino/aggapturbogames-double-roll",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/DoubleRoll.webp",
      alt: "Double Roll",
      name: "Double Roll",
      providerName: "Turbo Games",
    },
    FastFielder: {
      href: "/casino/aggapturbogames-fast-fielder",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/FastFielder.webp",
      alt: "Fast Fielder",
      name: "Fast Fielder",
      providerName: "Turbo Games",
    },
    FruitTowers: {
      href: "/casino/aggapturbogames-fruit-towers",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/FruitTowers.webp",
      alt: "Fruit Towers",
      name: "Fruit Towers",
      providerName: "Turbo Games",
    },
    Hamsta: {
      href: "/casino/aggapturbogames-hamsta",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Hamsta.webp",
      alt: "Hamsta",
      name: "Hamsta",
      providerName: "Turbo Games",
    },
    HiLo: {
      href: "/casino/aggapturbogames-hi-lo",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Hi-Lo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Turbo Games",
    },
    JavelinX: {
      href: "/casino/aggapturbogames-javelinx",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/JavelinX.webp",
      alt: "JavelinX",
      name: "JavelinX",
      providerName: "Turbo Games",
    },
    LimboRider: {
      href: "/casino/aggapturbogames-limbo-rider",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/LimboRider.webp",
      alt: "Limbo Rider",
      name: "Limbo Rider",
      providerName: "Turbo Games",
    },
    Mines: {
      href: "/casino/aggapturbogames-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Mines.webp",
      alt: "Mines",
      name: "Mines",
      providerName: "Turbo Games",
    },
    Neko: {
      href: "/casino/aggapturbogames-neko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Neko.webp",
      alt: "Neko",
      name: "Neko",
      providerName: "Turbo Games",
    },
    SaveThePrincess: {
      href: "/casino/aggapturbogames-save-the-princess",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/SaveThePrincess.webp",

      alt: "Save the Princess",
      name: "Save the Princess",
      providerName: "Turbo Games",
    },
    SpinStrike: {
      href: "/casino/aggapturbogames-spin-strike",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/SpinStrike.webp",
      alt: "Spin Strike",
      name: "Spin Strike",
      providerName: "Turbo Games",
    },
    Stairs: {
      href: "/casino/aggapturbogames-fury-stairs",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Stairs.webp",
      alt: "Stairs",
      name: "Stairs",
      providerName: "Turbo Games",
    },
    TradingDice: {
      href: "/casino/aggapturbogames-trading-dice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/TradingDice.webp",
      alt: "Trading Dice",
      name: "Trading Dice",
      providerName: "Turbo Games",
    },
    Towers: {
      href: "/casino/aggapturbogames-towers",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Towers.webp",
      alt: "Towers",
      name: "Towers",
      providerName: "Turbo Games",
    },
    TurboMines: {
      href: "/casino/aggapturbogames-turbo-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/TurboMines.webp",
      alt: "Turbo Mines",
      name: "Turbo Mines",
      providerName: "Turbo Games",
    },
    TurboPlinko: {
      href: "/casino/aggapturbogames-turbo-plinko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/TurboPlinko.webp",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
    },
    WicketBlast: {
      href: "/casino/aggapturbogames-wicket-blast",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/WicketBlast.webp",
      alt: "Wicket Blast",
      name: "Wicket Blast",
      providerName: "Turbo Games",
    },
    MagicKeno: {
      href: "/casino/aggapturbogames-magic-keno",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/MagicKeno.webp",
      alt: "Magic Keno",
      name: "Magic Keno",
      providerName: "Turbo Games",
    },
    Vortex: {
      href: "/casino/aggapturbogames-vortex",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/Vortex.webp",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Turbo Games",
    },
    Tap1Mines: {
      href: "/casino/aggapturbogames-1tap-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/1TapMines(InstantWin).webp",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      providerName: "Turbo Games",
    },
    TakeMyPlinko: {
      href: "/casino/aggapturbogames-take-my-plinko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/TakeMyPlinko.webp",
      alt: "Take My Plinko",
      name: "Take My Plinko",
      providerName: "Turbo Games",
    },
    Tap1MinesIW: {
      href: "/casino/qt-1tap-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/1TapMines.webp",
      alt: "1Tap Mines (Instant Win)",
      name: "1Tap Mines (Instant Win)",
      providerName: "Turbo Games",
    },
    DiceThrice: {
      href: "/casino/aggapturbogames-dice-thrice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/DiceThrice.webp",
      alt: "Dice Thrice",
      name: "Dice Thrice",
      providerName: "Turbo Games",
    },
    PumpedX: {
      href: "/casino/aggapturbogames-pumpedx",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/PumpedX.webp",
      alt: "PumpedX",
      name: "PumpedX",
      providerName: "Turbo Games",
    },
    DonnyKing: {
      href: "/casino/aggapturbogames-donny-king",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/DonnyKing.webp",
      alt: "Donny King",
      name: "Donny King",
      providerName: "Turbo Games",
    },
    CrystalPoker: {
      href: "/casino/aggapturbogames-crystal-poker",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/CrystalPoker.webp",
      alt: "Crystal Poker",
      name: "Crystal Poker",
      providerName: "Turbo Games",
    },
    MultiplayerMines: {
      href: "/casino/aggapturbogames-multiplayer-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/MultiplayerMines.webp",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
      providerName: "Turbo Games",
    },
    BookOfMines: {
      href: "/casino/aggapturbogames-book-of-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/BookOfMines.webp",
      alt: "Book of Mines",
      name: "Book of Mines",
      providerName: "Turbo Games",
    },
    JewelClicker: {
      href: "/casino/aggapturbogames-jewel-clicker",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/turbo/JewelClicker.webp",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
      providerName: "Turbo Games",
    },
  },
};
